import { render, staticRenderFns } from "./DialogChooseTeam.vue?vue&type=template&id=d03a7b1e&"
import script from "./DialogChooseTeam.vue?vue&type=script&lang=js&"
export * from "./DialogChooseTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports